// extracted by mini-css-extract-plugin
export default {"costSectionRow":"CostSection_costSectionRow__fEkV3","statsCol":"CostSection_statsCol__ZX6St","graphCol":"CostSection_graphCol__O0OZ6"};